import { useParams, Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

export default function InviteLanding() {
  const { code } = useParams<{ code: string }>();
  const { t } = useTranslation();

  const benefits = [
    t('invite.benefitMonitor'),
    t('invite.benefitAlerts'),
    t('invite.benefitBook'),
  ];

  return (
    <div className="flex min-h-screen flex-col bg-surface">
      {/* Header */}
      <header className="border-b border-border bg-surface/95 backdrop-blur-sm">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-primary-600 flex items-center justify-center">
              <span className="text-white font-bold text-sm">FM</span>
            </div>
            <span className="text-lg font-bold text-text-primary">FlyMind</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <Card variant="default" padding="lg" className="max-w-md w-full text-center">
          {/* Gift icon */}
          <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-primary-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.25-9.75h16.5"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-text-primary mb-4">
            {t('invite.landingTitle')}
          </h1>

          <ul className="text-left space-y-3 mb-8">
            {benefits.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-green-500 shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm text-text-secondary">{b}</span>
              </li>
            ))}
          </ul>

          <Link to={`/register?ref=${code}`}>
            <Button size="lg" className="w-full">
              {t('invite.cta')}
            </Button>
          </Link>
        </Card>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-6 text-center">
        <p className="text-sm text-text-secondary">{t('invite.footerTagline')}</p>
      </footer>
    </div>
  );
}
